import { useMsal } from "@azure/msal-react";
import type { EndSessionPopupRequest } from "@azure/msal-browser";
import { useNavigate } from "@tanstack/react-router";
import { useAdminStore } from "../stores/adminStore";
import { useMosquitoStore } from "../stores/mosquitoStore";
import { useSentinelStore } from "../stores/sentinelStore";
import { useVeterinaryStore } from "../stores/veterinaryStore";

export function useLogout() {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const clearUserDetail = useAdminStore((s) => s.clearUserDetail);

  return async (logoutRequest: EndSessionPopupRequest) => {
    // Clear user-specific store data before logout
    // Use clearUserDetail to also clear persisted sessionStorage
    clearUserDetail();
    useAdminStore.setState({
      organizations: [],
      users: [],
      roles: [],
      searchResults: [],
      mutations: [],
    });
    useMosquitoStore.setState({ sites: [], loading: false, error: null });
    useSentinelStore.setState({ flocks: [], loading: false, error: null });
    useVeterinaryStore.setState({
      incidents: [],
      caseSummaries: [],
      loading: false,
      error: null,
    });

    // Navigate to home before showing logout popup (feels more responsive)
    navigate({ to: "/" });

    await instance.logoutPopup(logoutRequest);
  };
}
